import {createAction} from 'typesafe-actions';

import * as Run from '../../../util/runs';
import * as GroupSelectionsTypes from '../groupSelections/types';
import * as Types from './types';

export const selectAllVisible = createAction(
  '@view/tempSelections/selectAllVisible',
  action => (ref: Types.Ref, groupSelectionsRef: GroupSelectionsTypes.Ref) =>
    action({ref, groupSelectionsRef})
);

export const selectNone = createAction(
  '@view/tempSelections/selectNone',
  action => (ref: Types.Ref, groupSelectionsRef: GroupSelectionsTypes.Ref) =>
    action({ref, groupSelectionsRef})
);

export const selectToggle = createAction(
  '@view/tempSelections/selectToggle',
  action =>
    (
      ref: Types.Ref,
      groupSelectionsRef: GroupSelectionsTypes.Ref,
      run: Run.Run,
      depth: number
    ) =>
      action({ref, groupSelectionsRef, run, depth})
);

export const selectSome = createAction(
  '@view/tempSelections/selectSome',
  action =>
    (
      ref: Types.Ref,
      groupSelectionsRef: GroupSelectionsTypes.Ref,
      runs: Run.Run[]
    ) =>
      action({ref, groupSelectionsRef, runs})
);

export const selectAll = createAction(
  '@view/tempSelections/selectAll',
  action => (ref: Types.Ref, groupSelectionsRef: GroupSelectionsTypes.Ref) =>
    action({ref, groupSelectionsRef})
);
